export interface ICreateOrUpdateContract {
  title: string;
  language: ContractLanguageEnum;
  content: string;
  contractVersionId?: string;
}

export interface IAssignContract {
  gymListingId: string;
  contractVersionId: string;
}

export enum ContractLanguageEnum {
  English,
  Greek,
}

export interface IContractForTable {
  id: string;
  title: string;
  version: string;
  content: string;
  language: ContractLanguageEnum;
  contractVersionId: string;
  contractId: string;
  createdAt: Date;
}

export interface IContract {
  id: string;
  title: string;
}

export interface IContractVersion {
  id: string;
  version: string;
  contractId: string;
  contract: IContract;
}

export interface IContractForAssign {
  id: string;
  title: string;
  contractVersions: IContractVersion[];
}
